import * as React from "react";
import styled from "@emotion/styled";

type BadgeProps = React.PropsWithChildren<{
  hide?: boolean;
  size?: number;
}>;

export default function Badge({ children, hide, size }: BadgeProps): JSX.Element {
  return (
    <BadgeComponent hide={hide} size={size}>
      {children}
    </BadgeComponent>
  );
}

const BadgeComponent = styled.span<{ hide?: boolean; size?: number }>(({ hide, size, theme }) => ({
  display: hide ? "none" : "inline-flex",
  fontWeight: 700,
  backgroundColor: theme.colors.sysBrandBlueDefault,
  borderRadius: 9,
  color: theme.colors.sysTextWhite,
  height: size ? size : 14,
  width: size ? size : 14,
  fontSize: size ? size - 6 : 8, // adjust font size based on size prop
  justifyContent: "center",
  alignItems: "center",
  marginLeft: 8,
}));
